import React from 'react';
import { useTranslation } from 'react-i18next';
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';

const STEP_KEYS = [
  'budgetPlanner.wizard.step1',
  'budgetPlanner.wizard.step2',
  'budgetPlanner.wizard.step3',
  'budgetPlanner.wizard.step4',
];

const STEP_DEFAULTS = ['Ingresos', 'Gastos fijos', 'Gastos variables', 'Metas'];

export default function WizardProgress({ activeStep }) {
  const { t } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box sx={{ mb: 3 }}>
      <Stepper
        activeStep={activeStep}
        alternativeLabel={!isMobile}
        orientation={isMobile ? 'vertical' : 'horizontal'}
        sx={{
          '& .MuiStepIcon-root.Mui-active': { color: '#1E3A5F' },
          '& .MuiStepIcon-root.Mui-completed': { color: '#2E7D32' },
          '& .MuiStepLabel-label.Mui-completed': { color: 'text.disabled', fontWeight: 400 },
          '& .MuiStepLabel-label.Mui-active': { fontWeight: 600, color: '#1E3A5F' },
          '& .MuiStep-root.Mui-completed .MuiStepConnector-line': { borderColor: '#2E7D32' },
        }}
      >
        {STEP_KEYS.map((key, i) => (
          <Step key={key}>
            <StepLabel>{t(key, STEP_DEFAULTS[i])}</StepLabel>
          </Step>
        ))}
      </Stepper>
    </Box>
  );
}
